<template>
    <div class="content-i">
        <div class="content-box">
            <div class=" single-page-container">
                <div class="col-sm-12 col-md-3 pl-0 pr-0 middle">
                    <SessionInfoBlock :mainUser="sessionInfoBlock.mainUser" :session="sessionInfoBlock.session" :totalProducts="products.length" :type="'copydesk'" :subtype="session && session.type" />
                </div>
                <div class="col-sm-12 col-md-6 middle">
                    <div class="support-index">
                        <div class="support-tickets">
                            <SessionTabs :tabOptions="tabOptions" :selectedTab="selectedTab" @sessionTabInterface="changeTab" />
                                <EmptyState v-if="products.length == 0 && session.type != 'review'" :height="170">
                                  <div slot="empty_state_text">
                                    There are no products in this session
                                  </div>
                              </EmptyState>
                              <div v-else v-show="selectedTab == 'Products'" class="support-ticket" v-for="product in products" @click="updateProductDetailsContainer(product)">
                                  <div class="st-meta">
                                      <i class="fas fa-check-circle" v-if="isQCApproved(product.product) == 1" :class="'qc-'+isQCApproved(product.product)"></i>
                                      <i class="fas fa-times-circle" v-if="isQCRejected(product.product) == 1" :class="'qc-'+isQCRejected(product.product)"></i>
                                  </div>
                                  <div class="st-body">
                                      <div class="avatar">
                                          <img alt="" :src="product.product.preview">
                                      </div>
                                      <div class="col-sm-4">
                                          <div class="ticket-content">
                                              <h6 class="ticket-title">
                                                  {{productDisplayName(product.product)}}
                                              </h6>
                                              <div class="ticket-description">
                                                  {{product.product.item_identifier}}
                                                  <br> {{product.product.brand}}
                                                  <br>
                                              </div>
                                          </div>

                                      </div>

                                      <div class="col-sm-3 b-r">
                                          <div class="el-tablo centered padded-v">
                                            <table class="table table-clean">
                                                <tbody>
                                                    <tr v-for="(language, key) in product.completion" v-if="language.percentage >= 0" >
                                                        <td>
                                                            <div class="value" :class="{'text-success': language.percentage == 100}">{{language.name}}</div>
                                                        </td>
                                                        <td class="text-right">
                                                            <div class="value bold" :class="{'text-success': language.percentage == 100}">({{language.completed || 0}}/{{language.required}})  {{language.percentage}}%</div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                  <!-- <div class="value text-center" v-if="product.completion.length < 1">NA</div> -->
                                            </table>
                                            <div class="label">Required</div>
                                          </div>
                                      </div>

                                      <div class="col-sm-3 b-r">
                                          <div class="el-tablo centered padded-v">
                                            <table class="table table-clean">
                                                <tbody>
                                                    <tr v-for="(language, key) in product.completion" v-if="language.percentage_optional >= 0" >
                                                        <td>
                                                            <div class="value" :class="{'text-success': language.percentage_optional == 100}">{{language.name}}</div>
                                                        </td>
                                                        <td class="text-right">
                                                            <div class="value bold" :class="{'text-success': language.percentage_optional == 100}">({{language.completed_optional || 0}}/{{language.optional}})  {{language.percentage_optional}}%</div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                  <!-- <div class="value text-center" v-if="product.completion.length < 1">NA</div> -->
                                            </table>
                                            <div class="label">Optional</div>
                                          </div>
                                      </div>

                                  </div>
                                  <div class="st-foot">
                                      <span class="label">Channel:</span>
                                      <span class="value"> {{product.product.channel_name}} </span>
                                      <span class="label">Category:</span>
                                      <span class="value"> {{product.product.category_name}} </span>
                                      <span class="label" v-if="session.type == 'review'">Dispatch Status:</span>
                                      <span class="value" :class="formatStatus(product.product.is_dispatch_success)" v-if="session.type == 'review'">
                                        <div v-if="product.product.is_dispatch_complete == 0">Pending</div>
                                        <div v-else-if="product.product.is_dispatch_complete == 1">
                                          <div v-if="product.product.is_dispatch_success == 1">Success</div>
                                          <div v-else>Failure
                                          </div>
                                          </div>
                                        <dir v-else>Unknown <i class="fas fa-sync mr-2" @click="retryProduct(product.product.id_product)"></i> Retry</dir>

                                      </span>
                                  </div>
                                  <div class="st-foot" v-if="session.is_import_session && product.product.notes">
                                      <span class="label">Import Notes:</span>
                                      <span class="value"> {{product.product.notes}} </span>
                                  </div>
                                  <div class="st-foot" v-if="session.type == 'review' && product.product.is_dispatch_success == 0">
                                      <span class="label">Dispatch Notes:</span>
                                      <span class="value"> {{product.product.dispatch_notes}} </span>
                                  </div>
                              </div>
                            <div v-show="selectedTab == 'Overview'">Empty Context</div>
                        </div>

                    </div>
                </div>
                <div class="col-sm-3 col-md-3 middle pl-0">
                  <SessionOverview :products="products" :session="session" :type="'copydesk'"/>
                </div>
                <!-- <div class="col-sm-12 col-md-3 middle">
                    <EmptyState v-if="selectedProduct == null">
                        <div slot="empty_state_text">
                            Select a product to see copy details
                        </div>
                    </EmptyState>
                    <RevisionWorkspace :product="selectedProduct" :revision="selectedProduct.id_copy_revision" v-else />
                </div> -->
            </div>
        </div>
    </div>
    </div>
</template>

<style scoped>
.support-index {
  display: block !important;
}
</style>

<script>
import Product from '@/mixins/product'
import SessionTabs from '@/components/common/SessionView/SessionTabs'
import SessionInfoBlock from '@/components/common/SessionView/SessionInfoBlock'

import RevisionWorkspace from '@/components/copydesk/RevisionWorkspace'
import SessionOverview from '@/components/photodesk/ViewSession/SessionOverview'

import EmptyState from '@/components/common/EmptyState'
import Loader from '@/components/common/Loader'

export default {
  name: 'session-view',
  props: ['id_session'],
  mixins: [Product],
  components: {
    SessionTabs,
    SessionInfoBlock,
    RevisionWorkspace,
    SessionOverview,
    Loader,
    EmptyState
  },
  mounted: function () {
    this.getSessionDetails()
  },
  data: function () {
    return {
      tabOptions: ['Products'],
      selectedTab: 'Products',
      copywriter: [],
      session: '',
      selectedProduct: null,
      products: {}
    }
  },
  methods: {
    getSessionDetails: function () {
      var self = this

      const url = '/copydesk/session/show'
      let data = {
        id_copydesk_session: self.id_session
      }

      self.$store.dispatch('updateLoading', 'true')
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
          // mode: 'no-cors',
        })
        .then(function (response) {
          self.mapProducts(response.data.products)
          self.session = response.data.session
          self.copywriter = response.data.copywriter
          self.$store.dispatch('updateLoading', 'false')
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateLoading', 'false')
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
        })
    },

    retryProduct: function (id_product) {
      var self = this

      const url = '/copydesk/product/retry'
      let data = {
        id_copydesk_session: self.id_session,
        id_product: id_product
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateToast', {
            text:
              'Request submitted',
            show: true
          })
          self.getSessionDetails()
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
        })
    },

    mapProducts (products) {
      var self = this
      self.products = Object.values(products).map(x => {
        let completion = {}
        x.map(x => {
          return completion[x['code']] = {
            'name': x['name'],
            'completed': x['required_headers_complete'],
            'required': x['required_headers'],
            'percentage': Math.round((x['required_headers_complete'] / x['required_headers']) * 100),
            'completed_optional': x['optional_headers_complete'],
            'optional': x['optional_headers'],
            'percentage_optional': Math.round((x['optional_headers_complete'] / x['optional_headers']) * 100)
          }
        })
        return { 'product': x[0], 'completion': completion }
      })

      console.log(self.products)
    },

    updateProductDetailsContainer: function (product) {
      this.selectedProduct = product
    },

    isQCApproved: function (product) {
      return product.qc_done == 1 && product.qc_state == 1 ? 1 : 0
    },
    isQCRejected: function (product) {
      return product.qc_done == 1 && product.qc_state == 0 ? 1 : 0
    },
    formatAvatar: function (user) {
      return 'background-image: url("http://52.66.102.131' + user.avatar + '")'
    },
    formatChannelAvatar: function (session) {
      return (
        'background-image: url("http://52.66.102.131/assets/images/channels/' +
        session.channel +
        '.svg"); background-size:50%; background-repeat: no-repeat;'
      )
    },
    formatStatus (status) {
      if (status == '1') {
        return 'qc-1'
      } else if (status == '0') {
        return 'qc-0'
      } else {
        return 'flagged'
      }
    },
    compareValues: function (vala, valb) {
      if (vala == valb && vala != 0) {
        return 'qc-1'
      }
    },
    changeTab: function (data) {
      this.selectedTab = data
    }
  },
  computed: {
    selectedProduct: function () {
      return this.selectedProduct
    },
    sessionInfoBlock () {
      return {
        mainUser: this.copywriter,
        session: this.session
      }
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
}
</script>

<style>
.qc-1 {
  color: #75da62 !important;
}

.qc-0 {
  color: #da6262 !important;
}

.flagged {
  color: #ffc107 !important;
}
.table.table-clean td .value {
  color: #000;
}
.table th, .table td {
  /* padding: 0.2rem; */
}
.bold {
  font-weight: 500 ! important;
}

</style>
